/* Remy offer: plan cards, quantity, thumbnails and the mobile sticky buy bar. No dependencies. */
(function () {
  function initOffer(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var uid = root.id.replace('remy-offer-', '');
    var planInput = root.querySelector('[data-plan-input]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var opts = root.querySelectorAll('.remy-offer__opt');
    var sticky = document.querySelector('[data-remy-sticky="' + uid + '"]');

    // Plan cards toggle the hidden selling_plan input (empty = one-time purchase).
    opts.forEach(function (opt) {
      var radio = opt.querySelector('input[type=radio]');
      radio.addEventListener('change', function () {
        opts.forEach(function (o) { o.classList.toggle('is-active', o === opt); });
        if (planInput) planInput.value = opt.dataset.plan || '';
        if (ctaLabel && opt.dataset.cta) ctaLabel.textContent = opt.dataset.cta;
        if (sticky) {
          sticky.querySelector('[data-sticky-price]').textContent = opt.dataset.price;
          sticky.querySelector('[data-sticky-name]').textContent = opt.dataset.name;
        }
      });
    });

    // Quantity stepper.
    var qty = root.querySelector('.remy-offer__qty input');
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.min(10, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(btn.dataset.qty)));
        qty.value = next;
      });
    });

    // Thumbnails swap the main image.
    var main = root.querySelector('[data-remy-main] img');
    root.querySelectorAll('.remy-offer__thumb').forEach(function (thumb, i, all) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = thumb.dataset.src;
        all.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    // Sticky bar: on once the hero button has scrolled away, off while the offer itself is on screen.
    if (!sticky) return;
    var hero = document.querySelector('.remy-hero__cta');
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var r = root.getBoundingClientRect();
      var offerVisible = r.top < vh && r.bottom > 0;
      var pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > vh * 0.6;
      var on = pastHero && !offerVisible;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      sticky.querySelector('[data-sticky-go]').tabIndex = on ? 0 : -1;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    sticky.querySelector('[data-sticky-go]').addEventListener('click', function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    update();
  }

  function initAll() { document.querySelectorAll('[data-remy-offer]').forEach(initOffer); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
